// extracted by mini-css-extract-plugin
export var termsPage = "index-module--termsPage--SR+Om";